import type { ReactNode } from 'react';
import type { ColumnDef } from '@tanstack/react-table';
import { PCMP_CHANNEL_LABELS } from '../../constants/pcmpProposal.constants';
import type { PcmpMisQueueItem, PcmpMisTab } from '../../types/pcmpMis.types';
import { MisExplanationCell } from '../PcmpQueue/PcmpQueueCells';
import { getPcmpQueueColumns } from '../PcmpQueue/pcmpQueueColumns';

interface PcmpMisColumnOptions<T extends PcmpMisQueueItem> {
  /** The queue tab; left out for a batch's members. */
  tab?: PcmpMisTab | undefined;
  leading?: ColumnDef<T>[] | undefined;
  renderActions: (item: T) => ReactNode;
}

export function getPcmpMisColumns<T extends PcmpMisQueueItem>({
  tab,
  leading,
  renderActions,
}: PcmpMisColumnOptions<T>): ColumnDef<T>[] {
  const showMisColumn = tab === 'NOT_VERIFIED' || tab === 'EXPLAINED';
  return getPcmpQueueColumns<T>({
    leading,
    afterAmounts: [
      {
        id: 'paymentSource',
        header: 'Payment Source',
        cell: ({ row }) => (
          <span className="whitespace-nowrap">
            {PCMP_CHANNEL_LABELS[row.original.paymentSource]}
          </span>
        ),
      },
    ],
    afterLanes: showMisColumn
      ? [
          {
            id: 'misExplanation',
            header: tab === 'EXPLAINED' ? 'Not Verified & Explanation' : 'Not Verified',
            cell: ({ row }) => <MisExplanationCell item={row.original} showText />,
          },
        ]
      : [],
    renderActions,
  });
}
